import { RULE_FIELD_CONFIG } from '../constants/evidenceDisposalConstants';

export const getFieldValue = (item, field) => {
  if (field === 'DaysInStorage') {
    if (!item.ReceivedDate) return null;
    return Math.floor((Date.now() - new Date(item.ReceivedDate).getTime()) / 86400000);
  }

  const fieldDef = RULE_FIELD_CONFIG.find((f) => f.value === field);
  if (fieldDef?.type === 'boolean') {
    // condition.value for boolean fields is the "Yes"/"No" label (see RULE_BOOLEAN_VALUE_OPTIONS),
    // so the item's real boolean needs the same conversion before the string comparison below.
    return item[field] ? 'Yes' : 'No';
  }

  return item[field];
};

export const evaluateCondition = (condition, item) => {
  const fieldValue = getFieldValue(item, condition.field);

  switch (condition.op) {
    case 'eq':
      return String(fieldValue ?? '') === String(condition.value ?? '');
    case 'neq':
      return String(fieldValue ?? '') !== String(condition.value ?? '');
    case 'gt':
      return Number(fieldValue) > Number(condition.value);
    case 'lt':
      return Number(fieldValue) < Number(condition.value);
    case 'gte':
      return Number(fieldValue) >= Number(condition.value);
    case 'lte':
      return Number(fieldValue) <= Number(condition.value);
    case 'contains':
      return String(fieldValue ?? '')
        .toLowerCase()
        .includes(String(condition.value ?? '').toLowerCase());
    default:
      return true;
  }
};

export const matchesRuleConditions = (item, conditions) => {
  if (!conditions.length) return true;
  return conditions.reduce((result, condition, index) => {
    const conditionResult = evaluateCondition(condition, item);
    if (index === 0) return conditionResult;
    return condition.logic === 'OR' ? result || conditionResult : result && conditionResult;
  }, true);
};
